import ProductListingLevels from '@deltek/specification-client/core/Constants/productListingLevels'
import { ContentLibrary } from '@deltek/specification-client/core/Models/product'
import FilterSelectText from 'bpm/components/SpecTable/filters/FilterSelectText'
import { ListingStatus } from 'bpm/pages/ProductsPage/ProductDetailsPage/components/ListingHeaderVariants/ListingStatusVariant'
import { processEnv } from 'components/configuration/environmentVariables'
import { FilterProps } from 'react-table'

const tableFilters: Record<
    string,
    ({
        column: { id, filterValue, setFilter },
    }: FilterProps<any>) => JSX.Element
> = {
    type: FilterSelectText({
        options: Object.values(
            processEnv.REACT_APP_EnableBadgelessCards === '1'
                ? ProductListingLevels.filter(
                      (item) =>
                          !['Premium MasterSpec', 'Premium'].includes(item)
                  )
                : ProductListingLevels.filter(
                      (item) => item !== 'Product Listing'
                  )
        ),
    }),
    hasManufacturerOptions: FilterSelectText({
        options: ['True', 'False'],
    }),
    isActive: FilterSelectText({ options: ['Active', 'Inactive'] }),
    submissionStatus: FilterSelectText({
        options: Object.values(ListingStatus).filter((status) => {
            if (processEnv.REACT_APP_EnableBadgelessCards === '1') {
                return ![
                    ListingStatus.PremiumReview,
                    ListingStatus.PremiumReviewBPMSubmitted,
                    ListingStatus.PremiumMasterSpecReview,
                    ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
                ].includes(status)
            } else {
                return ![
                    ListingStatus.InReview,
                    ListingStatus.BPMSubmitted,
                ].includes(status)
            }
        }),
    }),
    canAutoGenerateProductSpecification: FilterSelectText({
        options: ['Can auto generate', "Can't auto generate"],
    }),
    hasProductDetailNotes: FilterSelectText({
        options: ['Has Notes', 'None Available'],
    }),
    contentLibrary: FilterSelectText({
        options: Object.values(ContentLibrary),
    }),
}

export default tableFilters
